//assets
import { ReactComponent as ChangePwdRegularIcon } from '../assets/images/sidebar/ChangePwdRegular.svg';
import { ReactComponent as ChangePwdSelectedIcon } from '../assets/images/sidebar/ChangePwdSelected.svg';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const ChangePasswordMenu = {
    id: 'change-password',
    title: 'Change Password',
    type: 'item',
    name: 'change-password',
    url: '/change-password',
    selected_icon: ChangePwdSelectedIcon,
    icon: ChangePwdRegularIcon,
    breadcrumbs: false
};

export default ChangePasswordMenu;
